<template>
    <div>
        <form id="download" :action="downloadConfig.baseUrl + downloadConfig.action" method="POST"
              target="_blank">
            <!--<input type="hidden" name="token" :value="token"/>-->
            <input
                    v-for="item of downloadConfig.info"
                    type="hidden"
                    :key="downloadConfig.action+item.name"
                    :name="item.name"
                    :value="item.value"/>
        </form>
        <iframe name="exportIFrame" hidden></iframe>
    </div>
</template>
<script>
    import {mapState} from 'vuex'

    export default {
        computed: {
            ...mapState('other', ['downloadConfig']),
        }
    }
</script>